import { getRedirectUrl } from "../utils/sso-url-helper";
export const BHIdpLogout = (SID, clientId, ssoBaseUrl) => {
    let form = document.createElement('form');
    const redirectURL = getRedirectUrl('/en');
    form.action = `${ssoBaseUrl}/logout?client_id=${clientId}&sid=${SID}&post_logout_redirect_uri=${encodeURIComponent(redirectURL)}`;
    form.method = "POST";
    document.body.appendChild(form);
    form.submit();
};
